import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const BaseLayout = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content 1fr calc(16 * var(--unit));
  grid-template-areas: 'top' 'center' 'bottom';
  align-items: center;
  justify-items: center;
  overflow: hidden;
  gap: var(--double-unit);
  user-select: none;
  @media ${laptopAndAbove} {
    min-height: min(100vh - var(--unit) * 12, 600px);
  }
`;

export const TopArea = styled(Horizontal).attrs({ center: true })`
  grid-area: top;
  display: grid;
  grid-template-areas: 'topLeft topCenter topRight';
  grid-template-columns: auto 1fr auto;
  align-items: flex-start;
  padding: var(--double-unit) var(--double-unit) 0;
  width: 100%;
`;

export const BottomArea = styled.div`
  grid-area: bottom;
  padding: var(--unit) var(--double-unit) 0;
  &.hidden {
    visibility: hidden;
  }
`;

export const CenterArea = styled(Horizontal).attrs({ center: true })`
  --margin-bottom-center-area: calc(5 * var(--unit));
  margin: var(--triple-unit) 0 var(--margin-bottom-center-area) 0;
  grid-area: center;
  --stripe-height: 32px;
  --pack-aspect-ratio: 0.6334;
  --pack-width: 200px;
  --card-width: 190px;
  position: relative;
  min-height: 0;
  min-width: 0;
  width: var(--pack-width);
  height: 100%;
`;

export const CardWrapper = styled.div`
  height: 100%;
  aspect-ratio: var(--card-aspect-ratio);
`;
